import { formatDate } from '@btime/helpers'

export const getReplyValue = reply => {
  if (!reply) {
    return ''
  }
  if (reply.question.type.name === 'sign') {
    return reply.value.name
  }
  return reply.value
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question.id === questionId)
}

export const findReplyByFieldId = (replies, fieldId) => {
  return replies.find(reply => reply.field.id === fieldId)
}

export const filterReplyByQuestionId = (replies, questionId) => {
  return replies.filter(reply => reply.question.id === questionId)
}

export const toCurrency = value => {
  const invalid_values = ['N/A', '', NaN]
  if (invalid_values.includes(Number(value))) {
    return
  }
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

  return formatter.format(value)
}

export const getFieldValue = (fieldValues, fieldName) => {
  return fieldValues.find(fv => {
    return fv.field.name === fieldName
  })
}

export const toDateFormat = (date, format) => {
  if (!date) {
    return 'Não informada'
  }
  return formatDate(format, date)
}

export const findRepliesByParentReference = (replies, reference) => {
  return replies.find(
    reply => reply.question.parentReference && reply.question.parentReference.indexOf(reference) === 0
  )
}

export const filterRepliesByParentReference = (replies, reference) => {
  return replies.filter(
    reply => reply.question.parentReference && reply.question.parentReference.indexOf(reference) === 0
  )
}

export const sortAndReturnSelectedReplies = array => {
  return array
    .sort((a, b) => a.question.ordination - b.question.ordination)
    .map(item => {
      const department = findReplyByQuestionId(array, 1583)?.value
      const role = findReplyByQuestionId(array, 1584)?.value
      const optionsReply = filterRepliesByParentReference(array, item?.question?.reference).find(
        item => !['Sugestões para redução ou eliminação do risco'].includes(item?.question?.name)
      )
      const suggestionReply =
        filterRepliesByParentReference(array, item?.question?.reference).find(item =>
          ['Sugestões para redução ou eliminação do risco'].includes(item?.question?.name)
        )?.value || ''
      const np =
        filterRepliesByParentReference(array, item?.question?.reference).find(item =>
          ['NP'].includes(item?.question?.name)
        )?.value || undefined
      const question = item?.question?.name.split('?')[0]
      const suffix = optionsReply?.question?.name.split('?')[0]
      const questionsWithSuffix = [1601, 1603]
      const combineQuestions = [1632, 1920]
      const questionReply = questionsWithSuffix.includes(item?.question?.id)
        ? `${question}, ${suffix}`
        : combineQuestions.includes(item?.question?.id)
        ? `${question}, ${item?.value?.name}`
        : question

      const allowedQuestionsIds = [1632].includes(item?.question?.id)
      const isValidType =
        item?.question?.type?.name === 'checkbox' || item?.question?.type?.name === 'select' || allowedQuestionsIds
      const hasValue = !!item?.value
      const hasNotParenteReference = !item?.question?.parentReference
      const isExceptionSelectQuestions = [1595].includes(item?.question?.id)

      if (isValidType && hasValue && hasNotParenteReference) {
        if (isExceptionSelectQuestions) return null
        return {
          questionReply,
          suggestionReply,
          questionId: item?.question?.id,
          value: item?.value?.name || item?.value,
          categoryId: item?.question?.category?.id,
          categoryName: item?.question?.category?.name,
          suffix: optionsReply?.question?.name.split('?')[0] || '',
          suffixValue: optionsReply?.value,
          department,
          role,
          np
        }
      }
      return null
    })
    .filter(item => item !== null)
}

export const separateByCategoryId = array => {
  return array.reduce((acc, object) => {
    const categoryId = object.categoryId
    if (categoryId === 16) {
      acc['organizacaoTrabalho'] = acc['organizacaoTrabalho'] || []
      acc['organizacaoTrabalho'].push(object)
    }
    if (categoryId === 17) {
      acc['mobiliariosEquipamentos'] = acc['mobiliariosEquipamentos'] || []
      acc['mobiliariosEquipamentos'].push(object)
    }
    if (categoryId === 18) {
      acc['biomecanico'] = acc['biomecanico'] || []
      acc['biomecanico'].push(object)
    }
    if (categoryId === 19) {
      acc['ambientais'] = acc['ambientais'] || []
      acc['ambientais'].push(object)
    }
    if (categoryId === 20) {
      acc['psicossociaisCognitivos'] = acc['psicossociaisCognitivos'] || []
      acc['psicossociaisCognitivos'].push(object)
    }

    return acc
  }, {})
}

export const getNPCellColor = value => {
  if (value === 1) return '#34cc34'
  if (value >= 2 && value <= 6) return '#fbfb33'
  if (value >= 7 && value <= 16) return '#fb2b2b'
  return ''
}
